module.exports = __webpack_public_path__ + "img/yl3053.76e91b6c.png";